module.exports = __webpack_public_path__ + "static/media/binoculars.5814cac2.svg";